import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ChevronDownSmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props),
        React.createElement("path", { d: "M15.6478199,6.64528691 L16.3549267,7.35239369 L11.0627131,12.6461801 L11.0652534,12.6489483 L10.3581467,13.356055 L10.3557131,13.3531801 L10.3548199,13.3549267 L9.64771309,12.6478199 L9.64771309,12.6451801 L4.35471309,7.35228691 L5.06181987,6.64518013 L10.3547131,11.9381801 L15.6478199,6.64528691 Z", fillRule: "evenodd" })));
};
ChevronDownSmall.displayName = 'ChevronDownSmall';
export default ChevronDownSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChevronDownSmall.js.map